
import { Monitor, Globe, Briefcase, HeartHandshake } from 'lucide-react';
import { CapabilitiesProps } from './types';

export const Capabilities = ({ provider }: CapabilitiesProps) => {
  const hasAdditionalCapabilities = 
    provider.client_portal === true ||
    provider.international_capabilities === true ||
    provider.startup_friendly === true ||
    provider.nonprofit_experience === true;
    
  if (!hasAdditionalCapabilities) return null;
  
  return (
    <div className="mt-2 text-xs">
      <p className="font-medium mb-1">Capabilities:</p>
      <div className="flex flex-wrap gap-2">
        {provider.client_portal && (
          <div className="flex items-center px-2 py-0.5 bg-gray-100 text-gray-800 rounded-full">
            <Monitor className="h-3 w-3 mr-1" />
            <span>Client Portal</span>
          </div>
        )}
        {provider.international_capabilities && (
          <div className="flex items-center px-2 py-0.5 bg-indigo-100 text-indigo-800 rounded-full">
            <Globe className="h-3 w-3 mr-1" />
            <span>International</span>
          </div>
        )}
        {provider.startup_friendly && (
          <div className="flex items-center px-2 py-0.5 bg-emerald-100 text-emerald-800 rounded-full">
            <Briefcase className="h-3 w-3 mr-1" />
            <span>Startup Friendly</span>
          </div>
        )}
        {provider.nonprofit_experience && (
          <div className="flex items-center px-2 py-0.5 bg-rose-100 text-rose-800 rounded-full">
            <HeartHandshake className="h-3 w-3 mr-1" />
            <span>Nonprofit Exp</span>
          </div>
        )}
      </div>
    </div>
  );
};
